import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment.development';

async function main() {
  if (environment.production === true) {
    return Promise.resolve();
  }

  const { MockServiceWorker } = await import('./core/devtools/mock-server/browser');
  return MockServiceWorker.start({
    onUnhandledRequest: 'bypass'
  });
}
main().then(() => {
  bootstrapApplication(AppComponent, appConfig)
    .catch((err) => console.error(err));
});